import axios from '../utils/axios-auth';
/**
 * Create a new whiteboard for a meeting
 * @param meetingId - The ID of the meeting to create a whiteboard for
 * @returns The created whiteboard
 */
export const createWhiteboard = async (meetingId) => {
    try {
        const response = await axios.post('/api/whiteboards', {
            meeting_id: meetingId
        });
        if (!response.data.success) {
            throw new Error('Failed to create whiteboard');
        }
        return response.data.data;
    }
    catch (error) {
        console.error('Error creating whiteboard:', error);
        throw error;
    }
};
/**
 * Get a whiteboard by ID
 * @param whiteboardId - The ID of the whiteboard to get
 * @returns The whiteboard
 */
export const getWhiteboardById = async (whiteboardId) => {
    try {
        const response = await axios.get(`/api/whiteboards/${whiteboardId}`);
        if (!response.data.success) {
            throw new Error('Failed to get whiteboard');
        }
        return response.data.data;
    }
    catch (error) {
        console.error('Error getting whiteboard:', error);
        throw error;
    }
};
/**
 * Get a whiteboard by meeting ID
 * @param meetingId - The ID of the meeting to get the whiteboard for
 * @returns The whiteboard or null if none exists
 */
export const getWhiteboardByMeetingId = async (meetingId) => {
    try {
        const response = await axios.get(`/api/whiteboards/meeting/${meetingId}`);
        if (!response.data.success) {
            return null;
        }
        return response.data.data;
    }
    catch (error) {
        console.error('Error getting whiteboard by meeting ID:', error);
        // Return null instead of throwing if the whiteboard doesn't exist
        if (error.response && error.response.status === 404) {
            return null;
        }
        throw error;
    }
};
/**
 * Update whiteboard content
 * @param whiteboardId - The ID of the whiteboard to update
 * @param content - The new content
 * @returns The updated whiteboard
 */
export const updateWhiteboardContent = async (whiteboardId, content) => {
    try {
        const response = await axios.put(`/api/whiteboards/${whiteboardId}`, {
            content
        });
        if (!response.data.success) {
            throw new Error('Failed to update whiteboard');
        }
        return response.data.data;
    }
    catch (error) {
        console.error('Error updating whiteboard:', error);
        throw error;
    }
};
/**
 * Delete a whiteboard
 * @param whiteboardId - The ID of the whiteboard to delete
 * @returns Success status
 */
export const deleteWhiteboard = async (whiteboardId) => {
    try {
        const response = await axios.delete(`/api/whiteboards/${whiteboardId}`);
        return response.data.success;
    }
    catch (error) {
        console.error('Error deleting whiteboard:', error);
        throw error;
    }
};
export default {
    createWhiteboard,
    getWhiteboardById,
    getWhiteboardByMeetingId,
    updateWhiteboardContent,
    deleteWhiteboard
};
